import * as types from './types';
import { createToast, toastType } from '../../../common/ToastHelper';

export const getCreditCardPaymentReportAction = data => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(loadingCreditCardPaymentReportAction(true));
    MPWWebApi.postGenericInsertUpdate('Reports/CreditCardPayment', data)
      .then(response => {
        dispatch({
          type: types.GET_CREDITCARDPAYMENT_REPORT,
          payload: response,
        });
        dispatch(loadingCreditCardPaymentReportAction(false));
        if (response.data.Data === null || response.data.Data === '') {
          createToast(toastType.info, 'Results', 'No data found!', true);
        }
      })
      .catch(error => {
        dispatch({
          type: types.GET_CREDITCARDPAYMENT_REPORT_ERROR,
          payload: error.response,
        });
        dispatch(loadingCreditCardPaymentReportAction(false));
        if (
          error.response.data &&
          error.response.data.Errors &&
          error.response.data.Errors[0].Title === null
        ) {
          createToast(toastType.error, 'Error', 'Unable to view report', true);
        } else {
          createToast(
            toastType.error,
            error.response.data.Errors[0].Title,
            error.response.data.Errors[0].Message,
            true
          );
        }
      });
  };
};

export const loadingCreditCardPaymentReportAction = status => {
  return {
    type: types.CREDITCARDPAYMENT_REPORT_LOAD,
    payload: status,
  };
};

export const clearReportDataAction = () => {
  return {
    type: types.CLEAR_REPORT_DATA,
  };
};



// WEBPACK FOOTER //
// ./src/pages/creditcardpayment/state/actions.js